import { isNil } from 'lodash';
export var avatarColor = ['green', 'teal', 'blue', 'violet', 'magenta', 'red', 'orange', 'yellow'];
var getReserveColor = function getReserveColor(author) {
  return author !== null && author !== void 0 && author.name ? avatarColor[author.name.split('').reduce(function (acc, v) {
    return acc + v.charCodeAt(0);
  }, 0) % 9] : undefined;
};
export var getAvatarSettings = function getAvatarSettings(author) {
  var _author$name;
  return {
    image: author === null || author === void 0 ? void 0 : author.image,
    name: (_author$name = author === null || author === void 0 ? void 0 : author.name) !== null && _author$name !== void 0 ? _author$name : 'Бот',
    color: isNil(author === null || author === void 0 ? void 0 : author.color) ? getReserveColor(author) : avatarColor[Number(author.color)]
  };
};